import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { fetchRequest as getCourseAction } from '../../store/course/actions'
import { getCourseByCourseId } from '../../store/course/selectors';
import { Link } from 'react-router-dom';
import {
    Container, Col, Row, Card, CardImg, CardTitle, CardText, CardGroup, Alert,
    CardSubtitle, CardBody, Spinner, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Badge
} from 'reactstrap';
import { FaCheckCircle } from "react-icons/fa";
import { addRequest as addMyCourseAction, addClear as clearMyCourseAction} from '../../store/myCourse/actions'
import { UpdateUserProfile as UpdateUserProfileAction } from '../../store/user/UserActions';
import { IUser, IUserCourse } from '../../store/interface';
import { GeneralUtil } from '../../utils/generalUtil';

import '@fortawesome/fontawesome-free/css/all.css';
import { authProvider } from '../../utils/authProvider';
// @ts-ignore
import { store } from 'react-notifications-component';
//import myCourse from '../Course/myCourse';

const generalUtil: GeneralUtil = new GeneralUtil();

interface PropsFromState {
    route: any
    data: any
    userDB: IUser
    ui: any
}
interface IState {
    modalRedeem: boolean
    redeemCode : string
    cpdPointInfoIsOpen: boolean
}
interface PropsFromDispatch {
    fetchRequest: typeof getCourseAction
    addRequest: typeof addMyCourseAction
    addClear: typeof clearMyCourseAction
    UpdateUserProfile: typeof UpdateUserProfileAction
}

type AllProps = PropsFromState & PropsFromDispatch

class CourseDetailPage extends React.Component<AllProps,IState> {
    constructor(props: AllProps) {
        super(props);
        this.state = {
            modalRedeem : false,
            redeemCode : '',
            cpdPointInfoIsOpen : false
        };
        this.handleRedeemPopup = this.handleRedeemPopup.bind(this);
        this.handleRedeem = this.handleRedeem.bind(this);
        this.handleAddtoCart = this.handleAddtoCart.bind(this);
        this.redeemCodeChange = this.redeemCodeChange.bind(this);
        this.cpdPointInfoOpen = this.cpdPointInfoOpen.bind(this);
    }
    public componentDidMount() {
       // console.log("componentDidMount:" + this.props.data);
        const { fetchRequest: fr, data } = this.props;

        var searchParams: any = {};
        searchParams["courseId"] = this.props.route.match.params.id;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        if (data == undefined) {
            fr(searchParams);
        }

        this.props.addClear();
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log({ "prevProps": prevProps, "this.props": this.props });
        
        if ((prevProps.userDB._etag != this.props.userDB._etag) || (prevProps.userDB.processState != this.props.userDB.processState) ){
            if (this.props.userDB.processState === 1){  // Update success
                store.addNotification({
                    title: "Info",
                    message: "Added to cart successfully",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
            }
        }
    }
    
    constructCPDPoint(array: any) {
        let data: any = [];

        array.forEach((element: any) => {
            //data.push(element.profession + ": " + element.points + ", Ref No.: " + element.cpdRefNo);
            if (element.cpdDesc)
                data.push(element.profession + " (" + element.cpdDesc + ")");
            else
                data.push(element.profession + " (" + element.cpdRefNo + ")");
            // data.push("Engineer: 123");
        });

        return data.join("\r\n");
    }

    cpdPointInfoOpen(e:any){
        this.setState({ cpdPointInfoIsOpen: !this.state.cpdPointInfoIsOpen});
    }
    redeemCodeChange(e:any) {
        this.setState({redeemCode: e.target.value});
    }

    handleRedeemPopup(){
        this.setState({modalRedeem : !this.state.modalRedeem});
    }

    //handleAddtoCart = async (event: any) => {
    handleAddtoCart = async (verificationType:string) => {
        //console.log(verificationType);
        //verificationType : noVerification / Verification

        let valid = true;
        let subTotal = 0;
        let taxAmt = 0;
        let iCartItem: any = (this.props.userDB?.cart?.items) ? this.props.userDB?.cart?.items?.slice() : [];
        console.log(iCartItem);


        if (iCartItem.length > 0) {
            const index :number = iCartItem.map(function (item: any) { return item.courseId; }).indexOf(this.props.data.courseId);

            if (index !== -1) {
                valid = false;
                
                store.addNotification({
                    title: "Alert!",
                    message: "This course already existed in the cart",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
            }
        }

        let dataToProcess : any= {};
        dataToProcess.refNo =  this.props.data.referenceNumber;
        let pmtResponseData = await generalUtil.SubscribeValidation(dataToProcess);
        if (pmtResponseData.isSuccess){
            // Valid
        }else{
            valid = false;
            store.addNotification({
                title: "Alert!",
                message: "You have already subscribed to this course",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    showIcon: true
                }
            });
        }

        if (valid) {
            iCartItem.push({
                id: iCartItem.length + 1,
                courseId: this.props.data.courseId,
                title: this.props.data.title,
                refNo: this.props.data.referenceNumber,
                cpdPoints: this.props.data.cpdPoints,
                shortDesc: this.props.data.shortDesc,
                organisersId: this.props.data.organiser.id,
                organisersName: this.props.data.organiser.orgName,
                professionList : this.props.data.professionList,
                countryList : this.props.data.countryList,
                courseImg: this.props.data.videoThumbnailURL,
                currency : this.props.data.currency == null ? "MYR" : this.props.data.currency,
                priceType : "Normal",
                price: verificationType == "noVerification" ? Number(this.props.data.normalPrice) + Number(this.props.data.priceAdjNoVerification) : Number(this.props.data.normalPrice),
                verificationType : verificationType,
                noTracking : this.props.data?.noTracking == null? false: this.props.data?.noTracking,
                promoRuleLimitUse : 0,
                promoRuleSingleUserPerUser : false
            });
            
            iCartItem.forEach((element: any) => {
                subTotal += Number(element.price);
            });
            // taxAmt = (subTotal / 100) * 0; 
            taxAmt = 0;  // temporary set tax to 0% so tax amount should be hardcode as RM 0.00
    
            let newObj: any = {
                items: iCartItem.slice(),
                subTot: Number(subTotal.toFixed(2)),
                tax: Number(taxAmt.toFixed(2)),
                totAmt: Number((subTotal + taxAmt).toFixed(2)),
                billingInfo: {
                    name: '',
                    address: '',
                    phoneNo : '',
                    email: ''
                },
                pmtInfo: {
                    pmtMethod: '',
                    pmtStatus: 'Pending'
                }
            }
            
            this.props.UpdateUserProfile({
                cart: newObj,
            });
        }
    }
    
    public async GetEmailAdd():Promise<string>{
        let accountInfo = await authProvider.getAccountInfo();
        let email = accountInfo === null ? '' : accountInfo?.account.idToken.email;
        return email;
    }
    
    async handleRedeem(){
        
        var expiryDate = new Date();
        expiryDate.setDate(expiryDate.getDate() + this.props.data.userShelfLifeDays);

        let emailAdd = this.props.userDB?.emailAdd;
        if (emailAdd === '' || emailAdd === undefined ){
            emailAdd = await this.GetEmailAdd(); // Handle for User registered but haven't update user profile
        }

        const n:IUserCourse ={
            id: "",
            oId : "", 
            table: "",
            version : 1,
            orderNo : "", // Todo
            orderDT : new Date(),
            videoURL : this.props.data.videoURL,
            videoThumbnailURL : this.props.data.videoThumbnailURL,
            courseId : this.props.data.courseId,
            courseTitle : this.props.data.title,
            courseDuration : this.props.data.duration,
            organiser : this.props.data.organiser,
            courseYear : new Date().getFullYear(),
            cpdPoints : this.props.data.cpdPoints,
            refNo : this.props.data.referenceNumber,
            concentrationId:this.props.data.concentrationId,

            playUntilSeconds : 0,
            concentrationDurationSettingsJSON : this.props.data.concentrationDurationSettingsJSON,

            shelfLifeDays : this.props.data.userShelfLifeDays,
            expiryDT : expiryDate,

            startWatchDT : undefined,
            completeWatchDT : undefined,

            facePhotoURLList : [],
            userQuestion : [],
            feedback : [],

            feedbackSubmitted : false,
            certIsGenerated : false,
            
            certSerialNumber : "",
            certGeneratedOn : undefined,
            certFileName : "" ,

            createdDT : new Date(),
            createdBy : emailAdd,

            lastEdited : new Date(),
            lastEditedBy: emailAdd,

            redeemCode : this.state.redeemCode,   // Temporary for redemption Code,
            
            faceImageList : [],

            searchKeywords: this.props.data.title.toLowerCase( )
        }; //as MyCourse;
        this.props.addRequest(n);
    }

    FormatDate(date: Date) {
        var displayDate = new Date(date);
        var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' } as const;
        return displayDate.toLocaleDateString("en-US", options);
    }
    expiredReminder(date: Date) {
        const expiryDate = new Date(date);
        const today = new Date();
        const diffTime = Math.abs(expiryDate.getTime() - today.getTime()); 
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        if (diffDays < 30){
            return <Badge color="danger">Hurry up! Only {diffDays} day(s) remains</Badge>;
        }
    }
    
    GetImagePath(fileName: string){
        fileName = fileName.replace("/courses/","").replace("courses/","").replace(".jpg","_md.jpg");
        return "https://images.ultimatespro.com/images/" + fileName;
    } 
    GetFlyerPath(fileName: string){
        fileName = fileName.replace("/courses/","").replace("courses/","").replace(".jpg","_800x1280.jpg");
        return "https://images.ultimatespro.com/images/" + fileName;
    }
        
    public render() {

        //const id = 1;// Number(this.props.route.match.params.id);
        //const id = Number(this.props.route.match.params.id);
        const closeBtn = <button className="close" onClick={this.handleRedeemPopup}>&times;</button>;

        let course: any = this.props.data;
        //console.log("Course:"+course);
        if (course != undefined) {
            return (
                <Container>
                    <br />
                    <Row>
                        <Col lg="6" xs="12">
                            <h2>{course.title}</h2>
                            <p style={{whiteSpace: "pre-wrap", textAlign:"justify"}}>
                                {course.shortDesc}
                            </p>
                        </Col>
                        <Col lg="6" xs="12">
                            <img src={this.GetImagePath(course.videoThumbnailURL)} width="100%" alt=''/>
                        </Col>
                        <Col lg="12">
                            {
                                (course.verification && course.noVerification) && 
                                <h5 style={{fontWeight: 700}}>Please choose one of the options belows:</h5>
                            }
                            {/* <Button color="danger" onClick={this.handleRedeemPopup} style={{margin: "10px 0"}}><i className="fas fa-gift mr-1"></i>&nbsp;Redeem</Button> */}
                            {course.noVerification &&
                                <Row style={{backgroundColor: "#E8E8E8", padding: "10px", borderRadius:"10px", marginBottom:"5px"}}>
                                    <Col lg="8" xs="12">
                                        <h5 style={{fontWeight: 700}}>
                                            <img width='36px' src='data:image/svg+xml;base64,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' />
                                            Subscribe to this Course</h5>
                                        <p>Have access to this course materials and FAQ. This track does not include verified certification</p>
                                    </Col>
                                    <Col lg="4" xs="12" style={{textAlign:"right"}}>
                                        <Button color="info" onClick={this.handleAddtoCart.bind(this, "noVerification")} style={{margin: "10px 5px"}} disabled={this.props.userDB.processing}><i className="fas fa-cart-plus mr-1"></i>&nbsp;Subscribe <strong>( {course.currency == null ? "RM" : course.currency} {((Number(course.normalPrice) + Number(course.priceAdjNoVerification)).toFixed(2))} )</strong></Button>
                                    </Col>
                                </Row>
                            }
                            {course.verification &&
                                <Row style={{backgroundColor: "#E8E8E8", padding: "10px", borderRadius:"10px"}}>
                                    <Col lg="8" xs="12">

                                        <h5 style={{fontWeight: 700}}>
                                        <img width='36px' src='data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTQzLjk4LDQwLjk2NGMtMC44NDgtMC43MDctMi4xMDktMC41OTMtMi44MTcsMC4yNTZjLTAuNzA3LDAuODQ5LTAuNTkzLDIuMTA5LDAuMjU2LDIuODE3bDkuMzk5LDcuODMzICAgYzAuNDA1LDAuMzM3LDAuOTIyLDAuNTIyLDEuNDQ3LDAuNTIyYzAuMDc3LDAsMC4xNTUtMC4wMDQsMC4yMzMtMC4wMTJjMC42MDMtMC4wNjUsMS4xNjMtMC4zNzUsMS41MzUtMC44NTFsMjEuMTc0LTI2Ljk5NSAgIGMwLjY4Mi0wLjg2OSwwLjUzLTIuMTI2LTAuMzM5LTIuODA4Yy0wLjg2OS0wLjY4MS0yLjEyNS0wLjUzMS0yLjgwOCwwLjMzOWwtMjAuMDYyLDI1LjU4TDQzLjk4LDQwLjk2NHoiPjwvcGF0aD48cGF0aCBkPSJNNzQuNDUsODAuODE1YzAuNDE1LDAsMC44MDMtMC4yNiwwLjk0NS0wLjY3NWMwLjE4LTAuNTIxLTAuMDk4LTEuMDkxLTAuNjItMS4yNzFjLTAuMDk3LTAuMDMzLTkuNjY3LTMuMzY3LTEyLjIzNi03LjYzMSAgIGMtMC44MjItMi4zMTYtMi40NTgtOC41Ni0wLjY0NS0xMS4wNDNjMC4wMTctMC4wMjMsMC4wMi0wLjA1MiwwLjAzNS0wLjA3NmMwLjk0My0xLjExNywxLjcyNC0yLjI1LDIuMjU0LTMuMzEgICBjMS44MjYtMy42NTQsMi45MTItMTIuOTc1LDMuMjMtMTcuMzk0YzAuMDQtMC41NTEtMC4zNzQtMS4wMjktMC45MjUtMS4wNjljLTAuNTQxLTAuMDMyLTEuMDI5LDAuMzc1LTEuMDY5LDAuOTI2ICAgYy0wLjQ0NCw2LjE1MS0xLjYyNiwxMy44NDMtMy4wMjUsMTYuNjQzYy0wLjk5NSwxLjk4OC0zLDQuMzAxLTUuMzY0LDYuMTg0Yy0yLjM0OSwxLjg3LTQuNjQ2LDIuOTg3LTYuMTQ4LDIuOTg3ICAgYy0xLjUwMSwwLTMuNzk5LTEuMTE3LTYuMTQ4LTIuOTg3Yy0xLjEzNy0wLjkwNS0yLjE4Ni0xLjkxLTMuMDg0LTIuOTNjLTAuMDQ2LTAuMDctMC4wODEtMC4xNDktMC4xMy0wLjIxNyAgIGMtMC4wNjctMC4wOTItMC4xNTMtMC4xNTktMC4yNDEtMC4yMmMtMC43OTktMC45NTktMS40NjEtMS45MjEtMS45MDgtMi44MTdjLTIuMTAxLTQuMjAxLTMuNDc5LTE4LjYxMS0zLjEzMS0yMS41MzUgICBjMC43MzctNi4xOTYsMy44NjMtMTMuNTgyLDE0LjU3LTEzLjU4MmM1Ljk4NiwwLDEwLjI1MywyLjI4LDEyLjY4Myw2Ljc3N2MwLjI2MiwwLjQ4NSwwLjg2OCwwLjY2NywxLjM1NSwwLjQwNCAgIGMwLjQ4NS0wLjI2MywwLjY2Ny0wLjg3LDAuNDA0LTEuMzU1Yy0yLjc2Ny01LjEyLTcuNzYxLTcuODI2LTE0LjQ0My03LjgyNmMtMTIuODE2LDAtMTUuODc0LDkuNjE1LTE2LjU1NiwxNS4zNDYgICBjLTAuMzg1LDMuMjM3LDAuOTkxLDE3Ljk5MiwzLjMyOSwyMi42NjZjMC41NjksMS4xMzgsMS40MjMsMi4zNiwyLjQ2MywzLjU1OGMxLjU2NiwyLjYxMywwLjAxMyw4LjU1Ny0wLjc4NSwxMC44MDggICBjLTIuNTY2LDQuMjU4LTEyLjEzOSw3LjU5Ny0xMi4yMzYsNy42M2MtMC41MjIsMC4xOC0wLjc5OSwwLjc0OS0wLjYyLDEuMjcxYzAuMTQzLDAuNDE1LDAuNTMsMC42NzUsMC45NDUsMC42NzUgICBjMC4xMDgsMCwwLjIxOC0wLjAxOCwwLjMyNS0wLjA1NWMwLjQyNy0wLjE0NiwxMC40ODktMy42NTQsMTMuMzU5LTguNTkxbDAuMDc2LTAuMTYzYzAuMjQtMC42NjQsMS43NjYtNS4wNzgsMS41OTUtOC45MzQgICBjMC4yNTgsMC4yMjIsMC41MTcsMC40NDMsMC43ODMsMC42NTVjMi43NzEsMi4yMDcsNS4zOTcsMy40MjMsNy4zOTQsMy40MjNjMS45OTcsMCw0LjYyMy0xLjIxNiw3LjM5NC0zLjQyMyAgIGMwLjI4LTAuMjIzLDAuNTUzLTAuNDU0LDAuODIzLTAuNjg4Yy0wLjIwMSwzLjg3OCwxLjM0OCw4LjM2LDEuNTksOS4wM2wwLjA3NiwwLjE2M2MyLjg3MSw0LjkzNywxMi45MzMsOC40NDUsMTMuMzU5LDguNTkyICAgQzc0LjIzMiw4MC43OTgsNzQuMzQzLDgwLjgxNSw3NC40NSw4MC44MTV6Ij48L3BhdGg+PHBhdGggZD0iTTE1LjEzNSwyNy40NjljMC41NTIsMCwxLTAuNDQ4LDEtMVY5LjU1MmgxNi45MTdjMC41NTIsMCwxLTAuNDQ4LDEtMXMtMC40NDgtMS0xLTFIMTUuMTM1Yy0wLjU1MiwwLTEsMC40NDgtMSwxdjE3LjkxNyAgIEMxNC4xMzUsMjcuMDIxLDE0LjU4MywyNy40NjksMTUuMTM1LDI3LjQ2OXoiPjwvcGF0aD48cGF0aCBkPSJNODYuMjk4LDcuNTUySDY4LjM4MWMtMC41NTMsMC0xLDAuNDQ4LTEsMXMwLjQ0NywxLDEsMWgxNi45MTd2MTYuOTE3YzAsMC41NTIsMC40NDcsMSwxLDFzMS0wLjQ0OCwxLTFWOC41NTIgICBDODcuMjk4LDgsODYuODUxLDcuNTUyLDg2LjI5OCw3LjU1MnoiPjwvcGF0aD48cGF0aCBkPSJNODYuMjk4LDczLjIwNmMtMC41NTMsMC0xLDAuNDQ3LTEsMXYxNi45MTZINjguMzgxYy0wLjU1MywwLTEsMC40NDctMSwxczAuNDQ3LDEsMSwxaDE3LjkxN2MwLjU1MywwLDEtMC40NDcsMS0xVjc0LjIwNiAgIEM4Ny4yOTgsNzMuNjUzLDg2Ljg1MSw3My4yMDYsODYuMjk4LDczLjIwNnoiPjwvcGF0aD48cGF0aCBkPSJNMzMuMDUyLDkxLjEyMkgxNi4xMzVWNzQuMjA2YzAtMC41NTMtMC40NDgtMS0xLTFzLTEsMC40NDctMSwxdjE3LjkxNmMwLDAuNTUzLDAuNDQ4LDEsMSwxaDE3LjkxN2MwLjU1MiwwLDEtMC40NDcsMS0xICAgUzMzLjYwNCw5MS4xMjIsMzMuMDUyLDkxLjEyMnoiPjwvcGF0aD48L2c+PC9zdmc+' />    
                                            Subscribe Verified Track</h5>
                                        <p>Highlight your new knowledge with a verified certificate. Use this valuable credential to earn your CPD Point and advance your career.</p>
                                        <p>Benefits of the Verified Track
                                            <ul>
                                                <li>Earn multiple CPD Point whichever is applicable</li>
                                                <li>Verified certificate</li>
                                            </ul>
                                        </p>
                                    </Col>
                                    <Col lg="4" xs="12" style={{textAlign:"right"}}>
                                        <Button color="warning" onClick={this.handleAddtoCart.bind(this, "Verification")} style={{margin: "10px 5px"}} disabled={this.props.userDB.processing}><i className="fas fa-cart-plus mr-1"></i>&nbsp;Subscribe <strong>( {course.currency == null ? "RM" : course.currency} {course.normalPrice} )</strong></Button>
                                    </Col>
                                </Row>
                            }
                            {
                                this.props.userDB.processing && (<Spinner color="warning">&nbsp;</Spinner>)
                            }
                        </Col>
                    </Row>
                    <Row><Col lg="12"><hr/></Col></Row>
                    <Row><Col lg="12" xs="12"><h2 className="mb-4" >About this course</h2></Col></Row>
                    <Row>
                        <Col lg="6" xs="12" className="mb-2">
                            <p style={{whiteSpace: "pre-wrap", textAlign:"justify"}} 
                                dangerouslySetInnerHTML={{ __html:course.longDesc}}>
                                {/* {course.longDesc} */}
                            </p>
                            <h5>Program Outline</h5>
                            <table className="programOutlineTable">
                                <thead style={{fontWeight:"bold"}}>
                                    <tr>
                                        <td style={{textAlign:"center"}}>Duration</td>
                                        <td style={{textAlign:"center"}}>Module</td>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    course.programOutline?.map((e: any) =>
                                        <tr>
                                            <td style={{width:"20%", textAlign:"center"}}>{e.duration}</td>
                                            <td style={{width:"80%"}}>{e.program}</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </Col>
                        <Col lg="6" xs="12">
                            <table>
                                <tbody>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right"}}>Organized By&nbsp;:&nbsp;</td>
                                        <td>{course.organiser.orgName}</td>
                                    </tr>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right"}}>Published on&nbsp;:&nbsp;</td>
                                        <td>{this.FormatDate(course.publishedDT)}</td>
                                    </tr>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right"}}>Delisted on&nbsp;:&nbsp;</td>
                                        <td>{this.FormatDate(course.expiryDT)} {this.expiredReminder(course.expiryDT)} </td>
                                    </tr>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right"}}>Language&nbsp;:&nbsp;</td>
                                        <td>{course.languages.join(", ")}</td>
                                    </tr>
                                    <tr style={{whiteSpace: "nowrap"}}>
                                        <td style={{textAlign:"right"}}>Subtitle&nbsp;:&nbsp;</td>
                                        <td>{course.subtitle ? course.subtitle.length ==0? "N/A" : course.subtitle.join(", ") : "N/A"}</td>
                                    </tr>
                                    <tr style={{whiteSpace: "nowrap"}}>
                                        <td style={{textAlign:"right"}}>Reference Number&nbsp;:&nbsp;</td>
                                        <td>{course.referenceNumber}</td>
                                    </tr>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right"}}>Course Price&nbsp;:&nbsp;</td>
                                        <td>{course.currency == null ? "RM" : course.currency} {course.normalPrice}</td>
                                    </tr>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right"}}>Course Features&nbsp;:&nbsp;</td>
                                        <td>{
                                            course.courseFeatures? 
                                                course.courseFeatures.length == 0? "N/A" : 
                                                course.courseFeatures.map((e: any) =>
                                                    <div>
                                                        <FaCheckCircle color="green" style={{margin: "5px 0px"}} />&nbsp;{e}
                                                    </div> 
                                                )
                                                : "N/A"
                                            }
                                        </td>
                                    </tr>
                                    <tr style={{whiteSpace: "nowrap"}}>
                                        <td style={{textAlign:"right"}}>Verification Track&nbsp;:&nbsp;</td>
                                        <td>
                                            {course.verification && 
                                                <div>
                                                    <img width='36px' src='data:image/svg+xml;base64,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' />
                                                    Verification
                                                </div>
                                            }
                                            {course.noVerification && 
                                                <div>
                                                    <img width='36px' src='data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9JzMwMHB4JyB3aWR0aD0nMzAwcHgnICBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTAwIDEwMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PHBhdGggZD0iTTE1LjEzNiwyNy4yMTZjMC41NTIsMCwxLTAuNDQ4LDEtMVY5LjU1MmMwLTAuMTQsMC4xMTMtMC4yNTMsMC4yNTMtMC4yNTNoMTYuNjY0YzAuNTUyLDAsMS0wLjQ0OCwxLTFzLTAuNDQ4LTEtMS0xSDE1LjM4OCAgIGMtMC42OTIsMC0xLjI1MywwLjU2MS0xLjI1MywxLjI1M3YxNy42NjRDMTQuMTM2LDI2Ljc2OCwxNC41ODMsMjcuMjE2LDE1LjEzNiwyNy4yMTZ6Ij48L3BhdGg+PHBhdGggZD0iTTg2LjA0NSw3LjI5OUg2OC4zODJjLTAuNTUzLDAtMSwwLjQ0OC0xLDFzMC40NDcsMSwxLDFoMTYuNjYzYzAuMTQsMCwwLjI1MywwLjExMywwLjI1MywwLjI1M3YxNi42NjRjMCwwLjU1MiwwLjQ0NywxLDEsMSAgIHMxLTAuNDQ4LDEtMVY4LjU1MkM4Ny4yOTgsNy44Niw4Ni43MzcsNy4yOTksODYuMDQ1LDcuMjk5eiI+PC9wYXRoPjxwYXRoIGQ9Ik04Ni4yOTgsNzIuOTUzYy0wLjU1MywwLTEsMC40NDctMSwxdjE2LjY2NGMwLDAuMTQtMC4xMTMsMC4yNTMtMC4yNTMsMC4yNTNINjguMzgyYy0wLjU1MywwLTEsMC40NDctMSwxczAuNDQ3LDEsMSwxICAgaDE3LjY2M2MwLjY5MiwwLDEuMjUzLTAuNTYxLDEuMjUzLTEuMjUzVjczLjk1M0M4Ny4yOTgsNzMuNCw4Ni44NSw3Mi45NTMsODYuMjk4LDcyLjk1M3oiPjwvcGF0aD48cGF0aCBkPSJNMzMuMDUyLDkwLjg3SDE2LjM4OGMtMC4xNCwwLTAuMjUzLTAuMTEzLTAuMjUzLTAuMjUzVjczLjk1M2MwLTAuNTUzLTAuNDQ4LTEtMS0xcy0xLDAuNDQ3LTEsMXYxNy42NjQgICBjMCwwLjY5MiwwLjU2MSwxLjI1MywxLjI1MywxLjI1M2gxNy42NjRjMC41NTIsMCwxLTAuNDQ3LDEtMVMzMy42MDQsOTAuODcsMzMuMDUyLDkwLjg3eiI+PC9wYXRoPjxwYXRoIGQ9Ik03My4yNDcsMjUuNTgyYy0wLjc3MS0wLjc5LTIuMDM4LTAuODA1LTIuODI4LTAuMDMzTDUxLjQzMyw0NC4wOThMMzIuMTMxLDI1LjQ5MWMtMC43OTQtMC43NjYtMi4wNi0wLjc0NC0yLjgyOCwwLjA1MiAgIGMtMC43NjcsMC43OTUtMC43NDMsMi4wNjIsMC4wNTIsMi44MjhsMTkuMjE2LDE4LjUyM0wyOC41MzMsNjYuNDcxYy0wLjc5MSwwLjc3Mi0wLjgwNSwyLjAzOC0wLjAzMywyLjgyOCAgIGMwLjM5MiwwLjQwMSwwLjkxMSwwLjYwMywxLjQzMSwwLjYwM2MwLjUwNCwwLDEuMDA5LTAuMTg5LDEuMzk3LTAuNTY5bDIwLjEyNC0xOS42NjFsMjAuMDYyLDE5LjMzOSAgIGMwLjM4OCwwLjM3NSwwLjg4OCwwLjU2MSwxLjM4OCwwLjU2MWMwLjUyMywwLDEuMDQ4LTAuMjA1LDEuNDM5LTAuNjEyYzAuNzY3LTAuNzk1LDAuNzQ0LTIuMDYxLTAuMDUyLTIuODI3TDU0LjMxNCw0Ni44NzUgICBMNzMuMjEzLDI4LjQxQzc0LjAwNCwyNy42MzgsNzQuMDE4LDI2LjM3Miw3My4yNDcsMjUuNTgyeiI+PC9wYXRoPjxwYXRoIGQ9Ik0zNi40NjEsMjguNjhjMC40OTgsMC4yMzYsMS4wOTUsMC4wMjEsMS4zMzEtMC40NzljMi4zMTEtNC45MTIsNi42NDktNy40MDIsMTIuODkzLTcuNDAyICAgYzYuNTA1LDAsMTAuOTY3LDIuNjgxLDEzLjI2LDcuOTY3YzAuMTYzLDAuMzc3LDAuNTMxLDAuNjAzLDAuOTE4LDAuNjAzYzAuMTMyLDAsMC4yNjgtMC4wMjcsMC4zOTYtMC4wODMgICBjMC41MDctMC4yMiwwLjczOS0wLjgwOSwwLjUyLTEuMzE1Yy0xLjgxNC00LjE4NC01LjkwNi05LjE3MS0xNS4wOTQtOS4xNzFjLTYuOTg2LDAtMTIuMDcsMi45NTctMTQuNzAyLDguNTUgICBDMzUuNzQ3LDI3Ljg0OSwzNS45NjEsMjguNDQ1LDM2LjQ2MSwyOC42OHoiPjwvcGF0aD48cGF0aCBkPSJNNjUuMzg4LDM3Ljc4OEM2NS4xMzksNDIuNTcsNjQuMjI0LDQ5Ljg0Miw2My4wMiw1My45Yy0wLjE1NywwLjUyOSwwLjE0NiwxLjA4NiwwLjY3NSwxLjI0MyAgIGMwLjA5NSwwLjAyOCwwLjE5LDAuMDQxLDAuMjg0LDAuMDQxYzAuNDMyLDAsMC44My0wLjI4MSwwLjk1OS0wLjcxNmMxLjI2MS00LjI1LDIuMTg3LTExLjU1NywyLjQ0OC0xNi41NzYgICBjMC4wMjgtMC41NTItMC4zOTYtMS4wMjItMC45NDctMS4wNTFDNjUuODg2LDM2LjgwMiw2NS40MTcsMzcuMjM2LDY1LjM4OCwzNy43ODh6Ij48L3BhdGg+PHBhdGggZD0iTTM3LjcyMiw1NS43OGMwLjEwMywwLDAuMjA4LTAuMDE2LDAuMzEyLTAuMDVjMC41MjUtMC4xNzMsMC44MTEtMC43MzcsMC42MzgtMS4yNjNjLTEuNDA5LTQuMjktMi4zNDQtMTIuNDgyLTIuNTU3LTE2LjkzICAgYy0wLjAyNy0wLjU1Mi0wLjUyOS0wLjk3Mi0xLjA0Ny0wLjk1MWMtMC41NTIsMC4wMjctMC45NzgsMC40OTUtMC45NTEsMS4wNDdjMC4yMDQsNC4yNDYsMS4xMDUsMTIuNzQsMi42NTUsMTcuNDU5ICAgQzM2LjkxLDU1LjUxNCwzNy4zMDEsNTUuNzgsMzcuNzIyLDU1Ljc4eiI+PC9wYXRoPjxwYXRoIGQ9Ik03NC4zMjUsODAuODE1YzAuNDE1LDAsMC44MDMtMC4yNiwwLjk0NS0wLjY3NWMwLjE4LTAuNTIxLTAuMDk4LTEuMDkxLTAuNjItMS4yNzFjLTAuMDk3LTAuMDMzLTkuNjY2LTMuMzY2LTEyLjIzNS03LjYzMSAgIGMtMC4yNjktMC43Ni0yLjIyMi02LjQ2OC0xLjc5OC05LjkzYzAuMDA0LTAuMDM0LTAuMDA4LTAuMDY1LTAuMDA4LTAuMDk5YzAuMDc1LTAuMzI0LDAuMDA1LTAuNjc2LTAuMjQ3LTAuOTI5ICAgYy0wLjM5LTAuMzkyLTEuMDI0LTAuMzk1LTEuNDE0LTAuMDA0Yy0wLjY0NCwwLjY0MS0xLjMzMSwxLjI1My0yLjA0MywxLjgyMWMtMi4zNDksMS44Ny00LjY0NiwyLjk4Ny02LjE0OCwyLjk4NyAgIGMtMS41MDEsMC0zLjc5OS0xLjExNy02LjE0Ny0yLjk4N2MtMC41MzktMC40MjktMS4wNjktMC44OS0xLjU3Ni0xLjM2OGMtMC40MDItMC4zNzctMS4wMzYtMC4zNi0xLjQxNCwwLjA0MSAgIGMtMC4xNTEsMC4xNi0wLjIyMSwwLjM1OC0wLjI0NywwLjU2Yy0wLjA2MywwLjE0OC0wLjEwNCwwLjMwNy0wLjA4OCwwLjQ3OWMwLjMyLDMuNDQzLTEuNzAxLDguNzA2LTEuOTU0LDkuMzUxICAgYy0yLjU1Myw0LjI2Ni0xMi4xNDgsNy42MTEtMTIuMjQ2LDcuNjQ1Yy0wLjUyMiwwLjE4LTAuNzk5LDAuNzQ5LTAuNjIsMS4yNzFjMC4xNDMsMC40MTUsMC41MywwLjY3NSwwLjk0NSwwLjY3NSAgIGMwLjEwOCwwLDAuMjE4LTAuMDE4LDAuMzI1LTAuMDU1YzAuNDI3LTAuMTQ2LDEwLjQ4OS0zLjY1NCwxMy4zNTktOC41OTFsMC4wNjItMC4xMjZjMC4wODctMC4yMTQsMS44My00LjU1MiwyLjExNi04LjM5NCAgIGMwLjAzMSwwLjAyNSwwLjA1OSwwLjA1MywwLjA5LDAuMDc4YzIuNzcxLDIuMjA3LDUuMzk3LDMuNDIzLDcuMzk0LDMuNDIzYzEuOTk3LDAsNC42MjMtMS4yMTYsNy4zOTUtMy40MjMgICBjMC4xNTEtMC4xMiwwLjI5NS0wLjI1MSwwLjQ0NC0wLjM3NWMwLjI0NSwzLjkyNywxLjg4NSw4LjQ4OSwxLjk2OSw4LjcxOGwwLjA3NSwwLjE2MWMyLjg3MSw0LjkzNywxMi45MzMsOC40NDUsMTMuMzU5LDguNTkyICAgQzc0LjEwNyw4MC43OTgsNzQuMjE4LDgwLjgxNSw3NC4zMjUsODAuODE1eiI+PC9wYXRoPjwvZz48L3N2Zz4=' />
                                                    No Verification
                                                </div>
                                            }
                                        </td>
                                    </tr>
                                    <tr style={{whiteSpace: "pre-wrap"}}>
                                        <td style={{textAlign:"right", verticalAlign:"top", whiteSpace:"nowrap"}}>Credit Hours/Points&nbsp;:&nbsp;</td>
                                        <td>{
                                            course.cpdPoints? course.cpdPoints.length == 0? "N/A" : 
                                                course.cpdPoints.map((e: any) =>
                                                    <div style={{paddingBottom: "5px"}}>
                                                        <strong>{e.profession}</strong><br/>
                                                        <span>{e.cpdDesc}</span>
                                                        {e.cpdVerification && <div><span><FaCheckCircle color="green" />&nbsp;Required Verification</span></div>}
                                                    
                                                    </div> 
                                                )
                                                : "N/A"
                                            }
                                        </td>
                                        {/* JSON.stringify(course.cpdPoints, null, 4)} */}
                                    </tr>
                                    { 
                                        (course?.courseCPDPointURL != null && course?.courseCPDPointURL != '') &&
                                        <tr style={{whiteSpace: "pre-wrap"}}>
                                            <td style={{textAlign:"right", verticalAlign:"top", whiteSpace:"nowrap"}}></td>
                                            <td>
                                                <Button color="success" size="sm" onClick={this.cpdPointInfoOpen} style={{ marginBottom: '1rem' }}>View Details</Button>
                                            </td>
                                            <Modal isOpen={this.state.cpdPointInfoIsOpen} toggle={this.cpdPointInfoOpen} size={"lg"}>
                                                <ModalHeader toggle={this.cpdPointInfoOpen} close={this.cpdPointInfoOpen}>
                                                    Credit Hours/Points Details
                                                </ModalHeader>
                                                <ModalBody>
                                                    <img src={this.GetImagePath(course.courseCPDPointURL)} width="100%" alt=''/>
                                                </ModalBody>
                                                <ModalFooter>
                                                    <Button color="secondary" onClick={this.cpdPointInfoOpen}>Close</Button>
                                                </ModalFooter>
                                            </Modal>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row><Col lg="12"><hr/></Col></Row>
                    { (course?.courseFlyerURL != null && course?.courseFlyerURL != '') &&
                    <Row>
                        <Col lg="12">
                            <img src={this.GetFlyerPath(course.courseFlyerURL)} width="100%" alt=''/>
                        </Col>
                    </Row>
                    }
                    <Row><Col lg="12"><hr/></Col></Row>
                    <Row><Col lg="12" xs="12"><h2 className="mb-4" style={{textAlign: "center"}}>Trainers Details</h2></Col></Row>
                    {
                        course.trainerProfile.map((item: any) => 
                            <Row>
                                <Col lg="3" xs="12">
                                    <img 
                                        src={"https://images.ultimatespro.com/images/" + item.profileImgURL.replace(".jpg","_md.jpg") } 
                                        alt="Trainer Profile" 
                                        width={300} 
                                    />
                                    {/* <img src="/images/empty-200.png" /> */}
                                </Col>
                                <Col lg="9" xs="12">
                                    <table>
                                        <tbody>
                                            <React.Fragment>
                                                <tr>
                                                    <td style={{width: "150px", textAlign:"right"}}>Name&nbsp;:&nbsp;</td>
                                                    <td>{item.name}</td>
                                                </tr>
                                                <tr>
                                                    <td style={{textAlign:"right"}}>Professional&nbsp;:&nbsp;</td>
                                                    <td>{item.profession?.join(", ")}</td>
                                                </tr>
                                                {/* <tr>
                                                    <td style={{textAlign:"right"}}>Years of Experience&nbsp;:&nbsp;</td>
                                                    <td></td>
                                                </tr> */}
                                                <tr style={{whiteSpace: "pre-wrap"}}>
                                                    <td style={{textAlign:"right", verticalAlign:"top"}}>Profile&nbsp;:&nbsp;</td>
                                                    <td style={{textAlign:"justify"}}>{item.profile}</td>
                                                </tr>
                                                <tr><td colSpan={2}><hr/></td></tr>
                                            </React.Fragment>
                                        </tbody>
                                    </table>
                                </Col>
                            </Row>
                        )
                    }
                    {/* <br /><br /><br /><br /><br /> */}
                    <Modal isOpen={this.state.modalRedeem} toggle={this.handleRedeemPopup}>
                        <ModalHeader toggle={this.handleRedeemPopup} close={closeBtn}>Subscribe</ModalHeader>
                        <ModalBody>
                            Please enter redemption code
                            <div className="card p-2 mt-3">
                                <div className="input-group">
                                    <input type="text" className="form-control" placeholder="Enter redeem code here..." onChange={this.redeemCodeChange}
                                        disabled={this.props.ui.adding || this.props.ui.addState === 1}/>
                                    <div className="input-group-append">
                                        <Button type="submit" color="primary" onClick={this.handleRedeem} 
                                            disabled={this.props.ui.adding || this.props.ui.addState === 1}>
                                                <i className="fas fa-check mr-1"></i>&nbsp;Redeem
                                        </Button>
                                    </div>
                                </div>
                                <br />
                                <Alert color="success" isOpen={this.props.ui.addState === 1}>
                                    Successfully subscribe!
                                </Alert>
                                <Alert color="danger" isOpen={this.props.ui.addState === 2}>
                                    {this.props?.ui.errors??"Failed adding!"}
                                </Alert>  
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Spinner color="warning" hidden={!this.props.ui.adding} />                       
                            <Link className="btn btn-primary float-left" hidden={ (this.props.ui.addState === 1) ? false : true } to="/mycourses">Go to My Course</Link>
                            <Button color="secondary" onClick={this.handleRedeemPopup}  disabled={this.props.ui.adding}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    <br/><br/><br/><br/>
                </Container>
            )
        } else {
            return (
                <Container>
                    <Row>
                        <Col lg="12">Loading
                            <Spinner color="warning" hidden={this.props.ui.loading} />
                        </Col>
                    </Row>
                </Container>
            )
        }
    }
}

const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
    data: getCourseByCourseId(state, ownProps.route.match.params.id),
    userDB : state.userReducer,
    ui: state.mycourse.ui
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    UpdateUserProfile: UpdateUserProfileAction,
    fetchRequest: getCourseAction,
    addRequest: addMyCourseAction,
    addClear : clearMyCourseAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseDetailPage)
